module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/04-02.5c263d76.mp3";